import {
  A4_FREQUENCY_HZ,
  A4_MIDI_NOTE,
} from "@/constants/pitchCorrection/pitchReference";

export const frequencyToSemitones = (
  frequency: number,
  referenceFrequency?: number,
  referenceMidi?: number
) => {
  const resolvedReferenceFrequency = referenceFrequency ?? A4_FREQUENCY_HZ;
  const resolvedReferenceMidi = referenceMidi ?? A4_MIDI_NOTE;
  return (
    12 * Math.log2(frequency / resolvedReferenceFrequency) +
    resolvedReferenceMidi
  );
};
